import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AssetLoaderService {

  private readonly baseAssetRoute: string;

  constructor(private http: HttpClient) {
    this.baseAssetRoute = './assets';
  }

  public loadAssetWithRoute(route: string): Observable<any> {
    return this.http.get(`${this.baseAssetRoute}/${route}`);
  }

}
